import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Article from './Article';
import CenterTile from './CenterTile';
import Loader from './Loader';

export default function Board() {
    const [loading, setLoading] = useState(false);
    const [articles, setArticles] = useState([]);
    const [classes, setClasses] = useState("");
    const [isSearched, setIsSearched] = useState(false);

    useEffect(() => {
        getArticles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getArticles = async () => {
        setLoading(true);
        const res = await axios.get(`https://hn.algolia.com/api/v1/search?tags=front_page`);
        filterArticles(res.data.hits);
        setClasses("row-start-1 md:row-start-2 md:col-start-2");
        setIsSearched(false);
        setLoading(false);
    }

    const searchArticles = async (text) => {
        setLoading(true);
        const res = await axios.get(`https://hn.algolia.com/api/v1/search?query=${text}&tags=story`);
        filterArticles(res.data.hits);
        if (res.data.hits.length < 4) {
            setClasses("row-start-1 md:row-start-1 md:col-start-2");
        }
        setIsSearched(true);
        setLoading(false);
    };

    const filterArticles = async (articles) => {
        const filteredArticles = articles.filter(article => article.url);
        setArticles(filteredArticles);
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="py-8 px-4 md:px-0 mx-auto max-w-3xl grid grid-cols-1 md:grid-cols-3 gap-5">
                    {articles.map((article) => (
                        <Article key={article.objectID} article={article} />
                    ))}
                    {articles.length < 1 ? (
                        <>
                            <div
                                className="border border-zinc-900 dark:border-zinc-100 dark:text-white h-72 flex flex-col items-center justify-center row-start-1 md:row-start-1 md:col-start-1 text-xl font-bold text-center">
                                NOTHING
                            </div>
                                <CenterTile getArticles={getArticles} searchArticles={searchArticles} isSearched={isSearched} />
                            <div
                                className="border border-zinc-900 dark:border-zinc-100 dark:text-white h-72 flex flex-col items-center justify-center row-start-3 md:row-start-1 md:col-start-3 text-xl font-bold text-center">
                                FOUND
                            </div>
                        </>
                    ) : (
                        <CenterTile getArticles={getArticles} searchArticles={searchArticles} classes={classes} isSearched={isSearched} />
                    )}
                </div>
            )}
        </>
    )
}